import gql from 'graphql-tag';

import {fragments} from '../../graphql/views';

// note: the backend currently throttles the number of items you can fetch to 1000
export const USER_PROJECTS = gql`
  query UserProjects(
    $userName: String!
    $includeReports: Boolean!
    $first: Int = 10000
    $pattern: String
  ) {
    user(userName: $userName) {
      id
      teams {
        edges {
          node {
            id
            name
            projects(order: "-created_at", first: $first, pattern: $pattern) {
              edges {
                node {
                  id
                  name
                  entityName
                  reports: allViews(viewType: "runs")
                    @include(if: $includeReports) {
                    edges {
                      node {
                        id
                        ...ViewFragmentMetadata
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${fragments.viewMetadata}
`;

export const ALL_USER_PROJECTS_QUERY = gql`
  query AllUserProjects($userName: String!, $first: Int = 10000) {
    user(userName: $userName) {
      id
      projects(first: $first) {
        edges {
          node {
            id
            name
            access
            user {
              id
            }
            entityName
            totalRuns
            lastActive
            computeHours
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

/**
 * The `order: "lastActive"` parameter has been removed for performance reasons.
 * see: https://weightsandbiases.slack.com/archives/C03FM4XJQC9/p1653608816997939?thread_ts=1653593087.482379&cid=C03FM4XJQC9
 */
export const ALL_TEAM_PROJECTS_QUERY = gql`
  query AllTeamProjects($entityName: String!, $first: Int = 10000) {
    projects(first: $first, entityName: $entityName) {
      edges {
        node {
          id
          name
          entityName
          totalRuns
          lastActive
          computeHours
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
